/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultAttribute } from '../../models/api-response-paged-result-attribute';
import { PagedRequestAttribute } from '../../models/paged-request-attribute';

export interface SearchAttribute$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestAttribute
}

export function searchAttribute(http: HttpClient, rootUrl: string, params: SearchAttribute$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAttribute>> {
  const rb = new RequestBuilder(rootUrl, searchAttribute.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultAttribute>;
    })
  );
}

searchAttribute.PATH = '/v1/api/ui/referential/attribute/search';
